module.exports = __webpack_public_path__ + "static/media/microcentrifuge_lid_close.d9ffa812.svg";